import React from 'react';
import { useTranslation } from 'react-i18next';

import './NewSigningCardFooter.scss';

export interface INewSigningCardFooterProps {
  homeTeamCode: string;
  awayTeamCode: string;
  startTime: string;
  className?: string;
}

const NewSigningCardFooter: React.FC<INewSigningCardFooterProps> = ({ homeTeamCode, awayTeamCode, startTime, className }) => {
  const { t } = useTranslation();

  return (
    <div className={`new-signing-card-footer ${className}`}>
      <div className="new-signing-card-footer__team-row">
        <span className="new-signing-card-footer__team-code">{homeTeamCode}</span>
        <span className="new-signing-card-footer__seperator">{t('vs')}</span>
        <span className="new-signing-card-footer__team-code">{awayTeamCode}</span>
      </div>
      <div className="new-signing-card-footer__time-row">{startTime}</div>
    </div>
  );
};

export default NewSigningCardFooter;
